/* eslint-disable no-sequences */
/**
 * Picks the key-value pairs corresponding to the given keys from an object.
 */
export const pick = (obj, arr) =>
  arr.reduce((acc, curr) => (curr in obj && (acc[curr] = obj[curr]), acc), {});
